import { combineReducers } from '@reduxjs/toolkit'
import settings from './settingsSlice'

const reducer = combineReducers({
    settings,
})

export default reducer